var exports = {
  "p": "xdde3148b--7258f2--iframe",
  "x": "xdde3148b--7258f2--tour-appear",
};

module.exports = exports;
